import { createConfigContext } from '@global-website/library';

export const ConfigContext = createConfigContext();
